import React, {useContext} from 'react'
import {NullAsDefault, renderMail, renderPhone} from 'views/Shared'
import {Avatar, message} from "antd";
import {renderIf, renderIfElse} from "../../../Shared";
import {FaUserTie} from "react-icons/fa6";
import getAvatar from "../../../../helpers/getAvatar";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import copyToClipboard from "copy-to-clipboard";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import _ from 'lodash'
import {IoCopyOutline} from "react-icons/io5";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ItemInformation} from 'components/common/ItemInformation'
import {TeacherActionTypes} from "../../../AppLocals/Course";
import {PiLinkSimpleBold} from "react-icons/pi";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";
import {DoubleValueItem} from "../../../../components/common/DoubleValueItem";

export const renderTeacher = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        user,
        prefix_title,
        fullname,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
        teacher_idcode,
        contact_address,
        hashtags = "",
        gender,
    } = item ?? {}

    const {isSm} = useContext(LayoutContext)

    const tags = (hashtags || "").split(",").filter(e => !!e);

    return (
        <div key={index} className="p-4 flex gap-3 custom-item-render relative list-item">
            <Avatar
                size={40}
                className="flex flex-center background-200"
                src={getAvatar(item) || user?.avatar}
                icon={<FaUserTie size={20} className="text-color-500"/>}
            />
            <div className="flex flex-col">
                <h2>
                    {renderIfElse(
                        user,
                        <Link
                            to={getLinkToDetail(user)}
                            style={{marginBottom: 4}}
                            className="font-bold text-lg text-color-000 no-underline leading-snug">
                            {(user?.patron_saint_name || prefix_title) && (
                                <span className="mr-1 font-medium text-sm text-gray-600">
                                    {user?.patron_saint_name ? user?.patron_saint_name : prefix_title}
                                </span>
                            )}
                            {fullname}
                            <PiLinkSimpleBold size={11} className="ml-1 text-primary-400"/>
                        </Link>,
                        <div
                            onClick={() => {handleAction(TeacherActionTypes.TEACHER_READ, item)}}
                            style={{marginBottom: 4}} className="font-medium text-color-100 leading-snug cursor-pointer">
                            <span className="text-sm italic">{prefix_title}</span>
                            <span className="ml-1 font-bold text-lg text-color-000 hover:text-color-100">{fullname}</span>
                        </div>
                    )}
                </h2>
                <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                    {renderIf(
                        teacher_idcode,
                        <div className="tracking-wider">
                            <span className="text-color-400 whitespace-no-wrap">
                                {isSm ? '#' : `${t('teacher code')} : `}
                            </span>
                            <span
                                onClick={() => {
                                    copyToClipboard(teacher_idcode)
                                    message.info(t('copied'))
                                }}
                                className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                {teacher_idcode}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                        </div>
                    )}
                </div>
                <div className="my-2 border-b border-color-50"/>
                <div className="flex flex-col flex-1 gap-1">
                    {renderIf(
                        tags.length > 0,
                        <div className="flex gap-2">
                            {tags.map((ee, ii) => (
                                <span
                                    key={ii}
                                    style={{width: 'fit', padding: '2px 8px', fontSize: 10, borderRadius: 999}}
                                    className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                        {ee}
                                    </span>
                            ))}
                        </div>
                    )}
                    <div className="flex flex-col gap-1">
                        {_.some([date_of_birth, place_of_birth]) && (
                            <DatePlaceItem
                                showIcon={true}
                                label="date of birth"
                                date={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                place={place_of_birth}
                                className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            gender !== 0,
                            <ItemInformation
                                showIcon={true}
                                label="gender"
                                value={t(getLabelOfGender(gender))}
                                className="italic tracking-wider"
                            />
                        )}
                    </div>
                    {renderIf(
                        _.some([contact_phone, contact_email]),
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="contact"
                            valueFirst={renderPhone(contact_phone)}
                            labelSecond={contact_email && " - " || ''}
                            valueSecond={renderMail(contact_email)}
                            className="italic tracking-wider"
                        />
                    )}
                    {renderIf(
                        contact_address,
                        <ItemInformation
                            showIcon={true}
                            label="address"
                            value={contact_address}
                            className="italic tracking-wider"
                        />
                    )}
                </div>
            </div>
            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}
